import { valueToNumber } from '../../../../../../../utilz';

export const initialValues = {
  transportationMode: null,
  stops: [
    {
      stopTypeId: '1',
      editMode: true,
      isNew: true,
      countryCode: 'US',
      gridOperation: 1,
      stopSequence: 1,
      portName: null,
    },
    {
      stopTypeId: '2',
      editMode: true,
      isNew: true,
      countryCode: 'US',
      gridOperation: 1,
      stopSequence: 2,
      portName: null,
    },
  ],
};

export const distanceRules = [
  {
    validator: (_field, value) => {
      if (value && valueToNumber(value) <= 0) {
        return Promise.reject('Distance must be greater than 0');
      }
      return Promise.resolve();
    },
  },
];

export const transportationModeRules = (t) => [
  {
    required: true,
    message: t('translation:getQuote.transportationDetails.transportationMode.message'),
  },
];

export const stopTypeIdRules = (t, form) => [
  {
    validator: ({ field }, value) => {
      const fieldIndex = field.split('.')[1];
      const numberOfStops = form.getFieldsValue(true).stops.length;

      if (!value) {
        return Promise.reject(t('translation:getQuote.transportationDetails.stopType.message'));
      }

      if (Number(fieldIndex) === 0 && value !== '1' && numberOfStops > 1) {
        return Promise.reject('Stop Type for the first stop should be Pick Up');
      }
      if (Number(fieldIndex) === numberOfStops - 1 && value !== '2' && numberOfStops > 1) {
        return Promise.reject('Stop Type for the last stop should be Delivery');
      }

      return Promise.resolve();
    },
    required: true,
  },
];

export const stopSequenceRules = (t) => [
  {
    required: true,
    message: t('translation:getQuote.transportationDetails.stopNo.message'),
  },
];

export const countryCodeRules = (t) => [
  {
    required: true,
    message: t('translation:default.fields.country.message'),
  },
];

export const portCityRules = (t) => [
  {
    required: true,
    message: t('translation:default.fields.city.message'),
  },
];

export const portTypeRules = (form) => [
  {
    validator: ({ field }, value) => {
      const portNameValue = form.getFieldValue(['stops', field.split('.')[1], 'portName']);

      if (!value && portNameValue) {
        return Promise.reject('Port Type and Port Name must both be filled');
      }

      return Promise.resolve();
    },
  },
];

export const portNameRules = (form) => {
  return [
    {
      validator: ({ field }, value) => {
        const portTypeValue = form.getFieldValue(['stops', field.split('.')[1], 'portType']);
        if (!value && portTypeValue) {
          return Promise.reject('Port Type and Port Name must both be filled');
        }

        return Promise.resolve();
      },
    },
  ];
};

export const sequenceStopSorting = (a, b) => {
  if (a.stopSequence > b.stopSequence) return 1;
  if (a.stopSequence < b.stopSequence) return -1;
  return 0;
};

export const additionalStopsValidation = (form) => [
  {
    validator: () => {
      const stops = form.getFieldValue('stops');
      const isHavePickup = stops.some((item) => item.stopTypeId === '1');
      const isHaveDelivery = stops.some((item) => item.stopTypeId === '2');

      if (!isHavePickup || !isHaveDelivery) {
        return Promise.reject(
          'At least One pickup and Delivery Stop must be provided (Country and City) in order to save the quote.',
        );
      }

      return Promise.resolve();
    },
  },
];
